import { render, staticRenderFns } from "./kpi-ward.vue?vue&type=template&id=5b4fa77e&scoped=true"
import script from "./kpi-ward.vue?vue&type=script&lang=js"
export * from "./kpi-ward.vue?vue&type=script&lang=js"
import style0 from "./kpi-ward.vue?vue&type=style&index=0&id=5b4fa77e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4fa77e",
  null
  
)

export default component.exports